/*
 * @Author: KellyYang
 * @Date: 2022-06-28 10:09:17
 * @LastEditors: KellyYang
 * @Description: 产品服务
 */
import React, { Fragment } from "react";
import classify1 from "@/assets/img/case-page/classify1.png";
import classify2 from "@/assets/img/case-page/classify2.png";
import classify3 from "@/assets/img/case-page/classify3.png";
import caseLi1 from "@/assets/img/case-page/case-li1.png";
import caseLi2 from "@/assets/img/case-page/case-li2.png";
import caseLi3 from "@/assets/img/case-page/case-li3.png";
import caseLi4 from "@/assets/img/case-page/case-li4.png";
import banner from "@/assets/img/case-page/case-banner1.png";
import h5Banner from "@/assets/img/case-page/h5-case-banner.png";
import { isMobile } from '@/utils/utils';
import CastListCom from "./components/CastList";
import './index.less';

const CasePage = () => {
  const classifyData = [
    { img: classify1, title: '风险管理', content: '攻防兼备，让风险管理成为金融机构规模和利润增长的新引擎' },
    { img: classify2, title: '供应链金融',  content: '以金融科技为手段，实现四流合一，提升产业链各方价值' },
    { img: classify3, title: '产业金融', content: '聚焦产业金融场景，链接中小微企业和金融机构，促进产业金融业务发展' },
  ]
  const caseList = [
    { img: caseLi1, title: '某省级城商行客户价值管理实践', content: '公司与某城商行在存量客户价值挖掘展开深度合作。锦誉征信基于该行存量业务规模较小的现状，提出存量客户的价值挖掘方案，激活风险管控能力和客群放大潜力，攻防兼备，驱动行内业务规模性增长。', type: '风险管理', typeBg: '#FF9442' },
    { img: caseLi2, title: '某银行基建供应链解决方案',  content: '公司与某地方法人银行合作，围绕基建行业业态，从地方产业链上的客群切入，充分与工程行业重点资源平台及核心企业融合，真正实现产融结合，提升客户认可度，从我方优势“数字、征信及完整的金融服务能力”解决客户痛点问题，赋能行业进而赋能客户，帮助银行解决客户粘度和流量问题，避免了陷入单点分散和一锤子买卖的营销困局。' , type: '产业金融', typeBg: '#219EB8' },
    { img: caseLi3, title: '某银行供应链金融业务落地增长', content: '公司与某民营银行和某村镇银行合作供应链金融业务，并打造存货质押金融监管仓，通过对传统仓储、物流基础设施进行智慧物联网升级，对WMS、TMS运营系统进行数字化改造，完成对仓储数据，物流数据的交叉验真，形成可信数据池，并接入监管运营平台，实现动产全链管控。通过打造主体信用识别，反欺诈校验、实时库存管理、商品溯源管理，实时价格管理和极速处置几项监管能力，增加了中小贸易商的金融服务获得感，为产业链赋能，搭建利益共享的监管生态。', type: '供应链金融', typeBg: '#41A64C' },
    { img: caseLi4, title: '某城商行场景金融实践', content: '公司与某城商行在消费分期领域深度合作，落地首款面向运营商户消费分期场景金融产品，依托运营商户数据及三方数据进行数据挖掘，输出客户风险控制方案。', type: '产品赋能', typeBg: '#219EB8' },
  ]
  return (
    <Fragment>
      <div className={isMobile() ? 'case-page-mobile case-page' : 'case-page'}>
        <section>
          <div className="case-page-header" style={{ backgroundImage: `url(${isMobile() ? h5Banner : banner})` }}>
            <div className="header-box">
              <div className="banner-title">
                <span>
                  效率赋能、数据赋能、风险赋能
                </span>
              </div>
              <div className="banner-subtitle">
                <span>
                  为小微企业提供融资解决方案，为银行提供数字化转型服务
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="case-classify-warp">
          <div className="classify-list">
            {
              classifyData.map((item, index) => (
                <div className="classify-li" key={`classify-li-${index}`}>
                  <img src={item.img} alt="" className="classify-img" />
                  <div className="classify-content-box">
                    <div className="classify-title">
                      <span>
                        {item.title}
                      </span>
                    </div>
                    <div className="classify-content">{item.content}</div>
                  </div>
                </div>
              ))
            }
          </div>
        </section>
        <section className="case-list-warp">
          <CastListCom caseList={caseList} />
        </section>
      </div>
    </Fragment>
  )
}

export default CasePage;
